import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import ManualProductionEntryActions, { manualProductionEntryActionTypes } from '../../actions/production/manualProductionEntryActions';
import ManualProductionEntryServices from '../../services/production/manualProductionEntryServices';

/**
 * @param action
 */
function* _createManualProductionEntry(action) {
  try {
    yield put(ManualProductionEntryActions.createManualProductionEntryLoading(true));
    const mo = yield ManualProductionEntryServices.createManualProductionEntry(action.payload);
    if (mo.success) {
      yield put(TrackerActions.trackAction(manualProductionEntryActionTypes.CREATE_MANUAL_PRODUCTION_ENTRY.SUCCESS, mo.data));
      notification.open({
        type: 'success',
        message: 'Manual entry added successfully.',
        duration: 4,
        placement: 'top',
      });
      action.callback(mo?.data);
      yield put(ManualProductionEntryActions.createManualProductionEntryLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ManualProductionEntryActions.createManualProductionEntryLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(ManualProductionEntryActions.createManualProductionEntryLoading(false));
    yield put(TrackerActions.trackAction(manualProductionEntryActionTypes.CREATE_MANUAL_PRODUCTION_ENTRY.ERROR, error));
  }
}

/**
 *
 */
function* createManualProductionEntry() {
  yield takeLatest(manualProductionEntryActionTypes.CREATE_MANUAL_PRODUCTION_ENTRY.REQUEST, _createManualProductionEntry);
}

/**
 * @param action
 */
function* _getManualProductionEntries(action) {
  try {
    ManualProductionEntryActions.getManualProductionEntriesSuccess(null);
    yield put(ManualProductionEntryActions.getManualProductionEntriesLoading(true));
    const { payload, callback } = action;
    const manualProductionEntries = yield ManualProductionEntryServices.getManualProductionEntries(payload?.tenantId, payload?.peId, payload?.status, payload?.page, payload?.limit, payload?.searchKeyword, payload?.departmentId, payload?.fromDate, payload?.toDate, payload?.scheduledStartDate, payload?.scheduledEndDate);
    yield put(ManualProductionEntryActions.getManualProductionEntriesSuccess(manualProductionEntries));
    if (callback) {
      callback(manualProductionEntries);
    }
    yield put(ManualProductionEntryActions.getManualProductionEntriesLoading(false));
  } catch (error) {
    yield put(ManualProductionEntryActions.getManualProductionEntriesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRIES.ERROR, error));
  }
}

/**
 *
 */
function* getManualProductionEntries() {
  yield takeLatest(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRIES.REQUEST, _getManualProductionEntries);
}

/**
 * @param action
 */
function* _getManualProductionEntryById(action) {
  try {
    yield put(ManualProductionEntryActions.getManualProductionEntryByIdLoading(true));
    const {
      payload, callback,
    } = action;
    const selectedManualProductionEntry = yield ManualProductionEntryServices.getManualProductionEntries(payload?.tenantId, payload?.peId, '', '', '', '', '', '', '', '', '');
    yield put(ManualProductionEntryActions.getManualProductionEntryByIdSuccess(selectedManualProductionEntry?.production_entries?.[0]));
    yield put(ManualProductionEntryActions.getManualProductionEntryByIdLoading(false));
  } catch (error) {
    yield put(ManualProductionEntryActions.getManualProductionEntryByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRY_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getManualProductionEntryById() {
  yield takeLatest(manualProductionEntryActionTypes.GET_MANUAL_PRODUCTION_ENTRY_BY_ID.REQUEST, _getManualProductionEntryById);
}

/**
 * @param action
 */
function* _updateManualProductionEntryStatus(action) {
  try {
    yield put(ManualProductionEntryActions.updateManualProductionEntryStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const mo = yield ManualProductionEntryServices.updateManualProductionEntryStatus(payload);

    if (mo?.success) {
      notification.open({
        type: 'success',
        message: 'Entry status updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ManualProductionEntryActions.updateManualProductionEntryStatusLoading(false));
  } catch (error) {
    yield put(ManualProductionEntryActions.updateManualProductionEntryStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(manualProductionEntryActionTypes.UPDATE_MANUAL_PRODUCTION_ENTRY_STATUS.ERROR, error));
  }
}

/**
 *
 */
function* updateManualProductionEntryStatus() {
  yield takeLatest(manualProductionEntryActionTypes.UPDATE_MANUAL_PRODUCTION_ENTRY_STATUS.REQUEST, _updateManualProductionEntryStatus);
}

/**
 * @param action
 */
function* _deleteManualProductionEntry(action) {
  try {
    yield put(ManualProductionEntryActions.deleteManualProductionEntryLoading(true));
    const mo = yield ManualProductionEntryServices.deleteManualProductionEntry(action.payload);

    if (mo.success) {
      notification.open({
        type: 'success',
        message: ' Manufacturing Order successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ManualProductionEntryActions.deleteManualProductionEntryLoading(false));
  } catch (error) {
    yield put(ManualProductionEntryActions.deleteManualProductionEntryLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(manualProductionEntryActionTypes.DELETE_MANUAL_PRODUCTION_ENTRY.ERROR, error));
  }
}

/**
 *
 */
function* deleteManualProductionEntry() {
  yield takeLatest(manualProductionEntryActionTypes.DELETE_MANUAL_PRODUCTION_ENTRY.REQUEST, _deleteManualProductionEntry);
}

/**
 *
 */
export default function* manualProductionEntrySaga() {
  yield all([
    createManualProductionEntry(), getManualProductionEntries(), getManualProductionEntryById(), updateManualProductionEntryStatus(),
    deleteManualProductionEntry(),
  ]);
}
